import {
  fetchGetBuildingCategoryOffers,
  type IMappers,
} from 'shared/repositories/commercial-buildings/v1/get-building-category-offers';
import type { ICategoryOffers } from 'shared/types/buildingOffers';

import type { IGetBuildingCategoryOffersParams } from './types';
import { mapResponse200, mapResponse400 } from './utils';

/**
 * Объявления здания и корпусов в категории — для таблицы блока предложений. Вызывается из браузера,
 * при ошибке промис отклоняется: блок показывает «Попробовать снова»
 */
export const getBuildingCategoryOffers = async (params: IGetBuildingCategoryOffersParams): Promise<ICategoryOffers> => {
  const { httpApi, logger, parameters } = params;

  const mappers: IMappers<ICategoryOffers, ICategoryOffers> = {
    200: mapResponse200,
    400: mapResponse400,
  };

  try {
    return (await fetchGetBuildingCategoryOffers({ httpApi, parameters, mappers })) as ICategoryOffers;
  } catch (error) {
    logger.error(error as Error, {
      domain: 'services/getBuildingCategoryOffers',
      description: 'Ошибка получения объявлений здания',
      buildingId: parameters.buildingId,
    });

    throw error;
  }
};
